import { render, staticRenderFns } from "./AttributionsOrder.vue?vue&type=template&id=43d1b7b0"
import script from "./AttributionsOrder.vue?vue&type=script&lang=js"
export * from "./AttributionsOrder.vue?vue&type=script&lang=js"
import style0 from "./AttributionsOrder.vue?vue&type=style&index=0&id=43d1b7b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports